document.addEventListener("DOMContentLoaded", () => {
    function register_submit_form() {
        $("form").submit(function(e){
            e.preventDefault();
            e.stopPropagation();
        });
        $.validate({
            form: "#integration-interest-form",
            modules: "location",
            onSuccess: function() { submit_interest_form(); }
        });
    }

    function enable_resend_button_one_minute() {
        const endTime = new Date(Date.now() + 60 * 1000);

        const countdown_timer = setInterval(() => {
            const diff = endTime - new Date();
            let seconds = Math.floor(diff / 1000)
            if (seconds < 1){
                $('#resend-button').text("Resend code");
            } else {
                $('#resend-button').text("Resend code (" + String(seconds) + ")");
            }
        }, 500);
        
        var timer = setInterval(function(){
            $("#resend-button").removeAttr("disabled");
            $("#resend-button").tooltip('destroy');
            clearInterval(timer);
            clearInterval(countdown_timer);
        }, 60000);
    }

    function resend_code() {
        $("#resend-button").attr("disabled", true);
        $("#resend-button").tooltip('enable');
        var client_email = $("#email").val();
        var data = {
            "email": client_email,
        }
        $.post("/apps/request-integration/resend_code/", data, function(response){
            if (response.result == "success") {
                $("#verify-error-msg").text("Verification code was sent successfully!");
                $("#verify-error-msg").show();
                $("#verify-error-msg").css('color', '#1D1D1F');
                enable_resend_button_one_minute();
            } else {
                $("#verify-error-msg").html("<i class='fa-solid fa-circle-exclamation'></i> " + response.msg);
                $("#verify-error-msg").show();
                $("#verify-error-msg").css('color', '#D03026');
                
                if ( response.msg.includes("beginning") ||  response.msg.includes("This code has expired")) {
                    $("#resend-button").tooltip('destroy');
                }
            }
        });
    }
    function hide_error_msg() {
        $("#submit-error-msg").hide();
        $("#verify-error-msg").hide();
        $("#work-email-error").hide();
    }

    function hide_sibling_error_msg(el) {
        $(el).siblings('span').hide();
        $(el).css('border-color', '');
    }

    // Add event listeners
    const email_input = document.getElementById("email");
    const vcode_input = document.getElementById("vcode");
    const specify_input = document.getElementById("specify");
    const resend_button = document.getElementById("resend-button");

    email_input.addEventListener("input", (e) => {
        hide_error_msg();
    });
    vcode_input.addEventListener("input", (e) => {
        hide_error_msg();
    });
    specify_input.addEventListener("input", (e) => {
        hide_sibling_error_msg(e.target);
    });
    resend_button.addEventListener("click", (e) => {
        resend_code();
    });

    function submit_interest_form() {
        if ($('#submit_div').is(':visible')) {
            // Hide all error messages
            document.querySelectorAll('[id*="-error"]').forEach(el => {
                el.style.display = 'none';
            });

            var web_visitor_id = $.cookie('web_visitor_id');
            var first_name = $('#first-name').val().trim();
            var last_name = $('#last-name').val().trim();
            var organization = $('#organization').val().trim();
            var website = $('#website').val().trim();
            var client_email = $("#email").val().trim();
            var job_title = $('#job-title').val().trim();
            var country = $('#country').val().trim();
            var software_type = $('#software-type option:selected').text().trim();
            var specify = $('#specify').val().trim();
            var customers = $('#customers').val().trim();
            var details = $('#details').val().trim();

            // check recaptcha and send verification code
            var recaptcha_token = grecaptcha.getResponse();
            if (recaptcha_token == "") {
                $("#recaptcha-error").show();
                return;
            } else {
                $("#recaptcha-error").hide();
            }

            var data = {
                "web_visitor_id": web_visitor_id,
                "first_name": first_name,
                "last_name": last_name,
                "organization": organization,
                "website": website,
                "email": client_email,
                "job_title" : job_title,
                "country": country,
                "software_type": software_type,
                "specify": specify,
                "customers": customers,
                "details": details,
                "recaptcha_token": recaptcha_token,
            }
            $.post("/apps/request-integration/get_verification_code/", data, function(response) {
                var result = response.result;
                if (result == "success") {
                    $("#submit_div").hide();
                    $("#vcode_div").show();
                    enable_resend_button_one_minute();
                } else if (response.msg === "Email must be a work or organization email") {
                    $("#work-email-error").show();
                    //$("#submit-error-msg").text(response.msg);
                    $("#submit-error-msg").html("<i class='fa-solid fa-circle-exclamation'></i> " + response.msg);
                    $("#submit-error-msg").show();
                    return
                } 
                else {
                    //$("#submit-error-msg").text(response.msg);
                    $("#submit-error-msg").html("<i class='fa-solid fa-circle-exclamation'></i> " + response.msg);
                    $("#submit-error-msg").show();

                    $("#"+response.id).css('border-color', 'rgb(185, 74, 72)');
                    $("#"+response.id+"-error").show();
                }
            });
        } else {
            var client_email = $("#email").val();
            // verification code process
            var vcode = $("#vcode").val().trim();

            if (vcode == "") {
                $("#verify-error-msg").html("<i class='fa-solid fa-circle-exclamation'></i> Verification code cannot be empty");
                $("#verify-error-msg").show();
                $("#verify-error-msg").css('color', '#D03026');
                return
            } 

            var data = {
                "email": client_email,
                "vcode": vcode,
            };
            $("#vcode").val("");
            $.post("/apps/request-integration/submit/", data, function(response){
                if (response.result == "success") {
                    $("#integration-interest-form").hide();
                    $("#submit-success").show();
                } else {
                    $("#verify-error-msg").html("<i class='fa-solid fa-circle-exclamation'></i> " + response.msg);
                    $("#verify-error-msg").show();
                    $("#verify-error-msg").css('color', '#D03026');

                    if ( response.msg.includes("beginning") ||  response.msg.includes("This code has expired")) {
                        $("#verify-button").attr("disabled", true);
                        $("#resend-button").tooltip('destroy');
                    }
                }

                
            });
        }
    }


    $(document).ready(function(){
        register_submit_form();
        const solutionSelect = document.getElementById('software-type');
        const otherTypeContainer = document.getElementById('specify-container');
        const otherTypeInput = document.getElementById('specify');

        solutionSelect.addEventListener('change', function() {
            if (this.value === 'other') {
                otherTypeContainer.style.display = 'block';
                otherTypeInput.setAttribute('data-validation', 'required'); // Make the free response field required
            } else {
                otherTypeContainer.style.display = 'none';
                otherTypeInput.removeAttribute('data-validation');
            }
        });

        const input = document.getElementById("website");
        const urlRegex = /^(https:\/\/)([\w-]+\.)+[\w-]+(\/\S*)?$/;

        input.addEventListener("blur", function() {
            const error = document.getElementById("url-error")

            if (input.value && !urlRegex.test(input.value)) {
                
                input.closest(".form-group").classList.add("has-error");
                
                error.style.display = "block";

            } else if (input.value && urlRegex.test(input.value)) {
                input.closest(".form-group").classList.remove("has-error");
                error.style.display = "none";
            } else {
                error.style.display = "none";
            }
        });

        const formControls = document.querySelectorAll('.form-control');
        formControls.forEach(input => {
            input.addEventListener('blur', () => {
                const errorSiblings = Array.from(input.parentElement.children).filter(el =>
                    el !== input &&
                    el.id &&
                    el.id.includes('-error')
                );

                errorSiblings.forEach(errorEl => {
                    errorEl.style.display = 'none';
                });
            });
            input.addEventListener('input', () => {
                input.style.borderColor = 'unset';
            });
        });

        const verificationInput = document.getElementById("vcode")
        verificationInput.addEventListener("blur", function() {
            $("#verify-error-msg").hide();
        });

        // Activate tooltip
        $(function () {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });
    });
});